import { render, staticRenderFns } from "./Keywords.vue?vue&type=template&id=7e6133cc&"
import script from "./Keywords.vue?vue&type=script&lang=js&"
export * from "./Keywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports